export const BULK_IMPORT_LOG_TAB = {
  INPUTS: {
    MERCHANT: 'Merchant',
    QUEUE_STATUS: 'Queue Status',
    DATE_RANGE: 'Date Range',
    FILE_NAME: 'File Name',
  },
  GENERATE_LOG: 'Generate Log',
};
